export const UPDATE_LOADING = "Setze Laden für Aktion";
export const RESET_LOADING = "Resettet alle Loading States";
export const UPDATE_LOADING_META = "Setze Loading Meta im Store";
export const RESET_LOADING_META = "Entferne Loading Meta im Store";
